/* ============================================================
   DEAD FLIGHT ARROWS — dfa-effets.js
   Effets globaux : reveal « décoche » (IntersectionObserver),
   compteurs de précision. Respecte prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* --- Reveal « décoche » --- */
  function initReveals(root) {
    var cibles = (root || document).querySelectorAll('.dfa-reveal:not(.is-visible)');
    if (!cibles.length) return;
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      cibles.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    cibles.forEach(function (el) { io.observe(el); });
  }

  /* --- Compteurs de précision (specs héroïques) --- */
  function initCompteurs(root) {
    var compteurs = (root || document).querySelectorAll('[data-dfa-compteur]:not(.is-fait)');
    if (!compteurs.length) return;
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      compteurs.forEach(function (el) { el.classList.add('is-fait'); });
      return;
    }
    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        rouler(e.target);
      });
    }, { threshold: 0.4 });
    compteurs.forEach(function (el) { io.observe(el); });

    function rouler(el) {
      var final = el.textContent;
      var nombre = parseFloat(el.getAttribute('data-dfa-compteur'));
      if (isNaN(nombre)) { el.classList.add('is-fait'); return; }
      var decimales = (String(nombre).split('.')[1] || '').length;
      var debut = null;
      var duree = 400; /* sec, pas d'élastique */
      function pas(ts) {
        if (!debut) debut = ts;
        var p = Math.min((ts - debut) / duree, 1);
        el.textContent = final.replace(String(nombre), (nombre * p).toFixed(decimales));
        if (p < 1) { requestAnimationFrame(pas); }
        else { el.textContent = final; el.classList.add('is-fait'); }
      }
      requestAnimationFrame(pas);
    }
  }

  function initTout(root) {
    initReveals(root);
    initCompteurs(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTout(document); });
  } else {
    initTout(document);
  }

  /* Réinit dans l'éditeur de thème */
  document.addEventListener('shopify:section:load', function (e) { initTout(e.target); });

  /* Utilitaire monnaie partagé (format boutique) */
  window.dfaFormatMoney = function (cents, format) {
    var gabarit = format || (window.dfaShop && window.dfaShop.moneyFormat) || '{{amount}} $';
    var valeur = (cents / 100).toFixed(2);
    var virgule = valeur.replace('.', ',');
    return gabarit
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, virgule)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/g, valeur);
  };
})();
